import { ProductOrderList, ProductOrderModel } from 'src/models/InvoiceModel';
import GuessOrderProductItem from 'src/components/Elements/Guess/GuessOrderProductItem';
import { ProductList } from 'src/models/ProductModel';
import GuessOrderDisplayerHeader from 'src/components/Elements/Guess/GuessOrdersDisplayerHeader';

interface Props {
  order: ProductOrderList,
  products: ProductList,
}

export enum OrderColumn {
  quantity = '40px',
  product = '100%',
  price = '256px',
  taxes = '128px',
  discount = '128px',
  deductible = '128px',
  amount = '128px',
}

const GuessOrderDisplayer = (props: Props) => {
  const {
    order,
    products,
  } = props;

  const renderOrderProductItem = () => order.map((item, index) => (
    <GuessOrderProductItem
      key={`product-${index}`}
      index={index}
      order={item as ProductOrderModel}
      products={products} />
  ));

  return (
    <div>
      <GuessOrderDisplayerHeader />
      {renderOrderProductItem()}
    </div>
  );
};

export default GuessOrderDisplayer;
//
